<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
  <path fill-rule="evenodd" d="M.522 0A.522.522 0 0 0 0 .522v22.956c0 .288.234.522.522.522h22.956a.522.522 0 0 0 .522-.522V.522A.522.522 0 0 0 23.478 0H.522Zm19.932 7.52a1.043 1.043 0 0 0-1.476-1.475l-9.696 9.697-4.11-4.11a1.043 1.043 0 0 0-1.475 1.476l4.847 4.847a1.044 1.044 0 0 0 1.475 0L20.454 7.52Z"/>
</svg>
